import stanfordCardinal from "./ticketBackTexts/stanford-cardinal";
import knicks from "./ticketBackTexts/knicks";
import fireflies from "./ticketBackTexts/fireflies";

type Dict = {
  [keys: string]: string | undefined;
};
const ticketBackTexts: Dict = {
  "stanford-cardinal": stanfordCardinal,
  knicks,
  fireflies,
};

export default (tenantSubdomain: string) => {
  if (tenantSubdomain && ticketBackTexts[tenantSubdomain]) {
    return ticketBackTexts[tenantSubdomain];
  }
};
